import { render, staticRenderFns } from "./SingleAgency.vue?vue&type=template&id=115fa9b6"
import script from "./SingleAgency.vue?vue&type=script&lang=ts"
export * from "./SingleAgency.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports